var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "310px",
    height: "297px",
    viewBox: "90 80 100 80",
    id: "svg25374",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs25371"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27220"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#074e9c",
      strokeWidth: 1.21048,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect294183-7-4-5",
    width: 79.131294,
    height: 24.196283,
    x: 101.08099,
    y: 99.633827
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0424\\u0430\\u043C\\u0438\\u043B\\u0438\\u044F \\u0418\\u043C\\u044F \\u041E\\u0442\\u0447\\u0435\\u0441\\u0442\\u0432\\u043E (\\u0432\\u0440\\u0430\\u0447\\u0430)",
    id: "text122494",
    style: {
      fontSize: "4.23333px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      display: "inline",
      fill: "#064e9d",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 144.18605,106.59015 h 0.0455 q 0.34726,0 0.63045,0.1571 0.28525,0.15503 0.44235,0.43821 0.15916,0.28319 0.15916,0.63666 0,0.35139 -0.15916,0.63251 -0.1571,0.27906 -0.43822,0.43409 -0.27905,0.15503 -0.62632,0.15709 h -0.0537 v 0.39274 h -0.50229 v -0.39274 h -0.0496 q -0.34933,0 -0.63459,-0.15503 -0.28525,-0.15709 -0.44235,-0.43615 -0.15503,-0.27905 -0.15503,-0.62838 0,-0.35347 0.1571,-0.63665 0.15709,-0.28319 0.44028,-0.44029 0.28319,-0.15916 0.63459,-0.15916 h 0.0496 v -0.40928 h 0.50229 z m -0.5519,0.41961 q -0.34727,0 -0.54364,0.21704 -0.1943,0.21704 -0.1943,0.59945 0,0.37207 0.1943,0.58704 0.19431,0.21291 0.54984,0.21291 h 0.0434 v -1.61644 z m 0.5519,0 v 1.61644 h 0.0496 q 0.34727,0 0.5395,-0.21704 0.19431,-0.21704 0.19431,-0.58704 0,-0.37828 -0.19431,-0.59532 -0.19223,-0.21704 -0.5457,-0.21704 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.20395,109.31453 q -0.0331,-0.0641 -0.0579,-0.20877 -0.23978,0.25011 -0.58705,0.25011 -0.33693,0 -0.54984,-0.19224 -0.2129,-0.19223 -0.2129,-0.47542 0,-0.3576 0.26458,-0.54777 0.26665,-0.19223 0.76068,-0.19223 h 0.30799 v -0.14677 q 0,-0.17363 -0.0971,-0.27698 -0.0971,-0.10542 -0.29559,-0.10542 -0.17157,0 -0.28112,0.0868 -0.10956,0.0847 -0.10956,0.21704 h -0.50229 q 0,-0.18397 0.12196,-0.34313 0.12195,-0.16123 0.33073,-0.25219 0.21083,-0.0909 0.46922,-0.0909 0.39274,0 0.62631,0.19844 0.23358,0.19637 0.23978,0.55397 v 1.00873 q 0,0.30179 0.0847,0.48162 v 0.0351 z m -0.5519,-0.36174 q 0.14883,0 0.27905,-0.0723 0.13229,-0.0724 0.19844,-0.19431 v -0.42167 h -0.27079 q -0.27905,0 -0.41961,0.0971 -0.14056,0.0971 -0.14056,0.27492 0,0.14469 0.0951,0.23151 0.0972,0.0847 0.25838,0.0847 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.48598,108.69648 0.66146,-1.6185 h 0.62838 v 2.23655 h -0.50229 v -1.48001 l -0.61598,1.48001 h -0.34107 l -0.61805,-1.48828 v 1.48828 h -0.50229 v -2.23655 h 0.63252 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.73539,107.07798 h 0.50023 v 2.23655 h -0.50023 v -1.49241 l -0.87643,1.49241 h -0.50023 v -2.23655 h 0.50023 v 1.49241 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.67061,107.07798 v 2.23655 h -0.50229 v -1.83141 h -0.63252 l -0.0413,0.77928 q -0.0393,0.56224 -0.21704,0.80822 -0.1757,0.24391 -0.5395,0.24391 h -0.15503 l -0.002,-0.41755 0.10335,-0.0103 q 0.16537,-0.0227 0.23978,-0.20051 0.0765,-0.17983 0.0971,-0.65319 l 0.0413,-0.95497 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.60124,107.07798 h 0.50023 v 2.23655 h -0.50023 v -1.49241 l -0.87643,1.49241 h -0.50023 v -2.23655 h 0.50023 v 1.49241 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.42691,107.07798 v 2.23655 h -0.50023 v -0.82062 h -0.46922 l -0.47749,0.82062 h -0.5209 l 0.5271,-0.9033 q -0.20671,-0.0868 -0.31833,-0.24805 -0.10955,-0.16123 -0.10955,-0.37 0,-0.31213 0.23978,-0.51057 0.24184,-0.2005 0.65112,-0.20463 z m -1.36633,0.7276 q 0,0.14056 0.10336,0.22944 0.10542,0.0868 0.26871,0.0868 h 0.49403 v -0.64492 h -0.46302 q -0.18397,0 -0.29352,0.093 -0.10956,0.093 -0.10956,0.23565 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 131.61215,111.59656 h 0.52297 v 3.00963 h -0.52297 v -2.14353 l -1.32085,2.14353 h -0.52296 v -3.00963 h 0.52296 v 2.1456 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.04094,113.98814 0.66146,-1.6185 h 0.62839 v 2.23655 h -0.5023 v -1.48001 l -0.61598,1.48001 h -0.34107 l -0.61805,-1.48828 v 1.48828 h -0.50229 v -2.23655 h 0.63252 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 137.68516,112.36964 v 2.23655 h -0.50023 v -0.82062 h -0.46922 l -0.47749,0.82062 h -0.5209 l 0.5271,-0.9033 q -0.2067,-0.0868 -0.31832,-0.24805 -0.10956,-0.16123 -0.10956,-0.37 0,-0.31213 0.23978,-0.51056 0.24185,-0.20051 0.65112,-0.20464 z m -1.36632,0.7276 q 0,0.14056 0.10335,0.22944 0.10542,0.0868 0.26872,0.0868 h 0.49402 v -0.64492 h -0.46302 q -0.18396,0 -0.29352,0.093 -0.10955,0.093 -0.10955,0.23564 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.74693,113.17992 q 0,0.44235 -0.15297,0.77722 -0.15296,0.33279 -0.43821,0.51263 -0.28319,0.17776 -0.65319,0.17776 -0.36587,0 -0.65319,-0.17776 -0.28525,-0.17984 -0.44235,-0.51057 -0.15503,-0.33073 -0.1571,-0.76274 v -0.1695 q 0,-0.44028 0.15503,-0.77721 0.1571,-0.33693 0.44029,-0.5147 0.28525,-0.17983 0.65318,-0.17983 0.36794,0 0.65113,0.17776 0.28525,0.1757 0.44028,0.5085 0.15503,0.33073 0.1571,0.77101 z m -0.52297,-0.15709 q 0,-0.50023 -0.19017,-0.76688 -0.1881,-0.26665 -0.53537,-0.26665 -0.33899,0 -0.53123,0.26665 -0.19017,0.26458 -0.1943,0.75034 v 0.17363 q 0,0.4961 0.19223,0.76688 0.19431,0.27079 0.53744,0.27079 0.34726,0 0.5333,-0.26459 0.1881,-0.26458 0.1881,-0.77308 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 143.97935,112.76858 h -0.72554 v 1.83761 h -0.5023 v -1.83761 h -0.71726 v -0.39894 h 1.9451 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 146.10635,114.60619 h -0.5023 v -0.74621 q -0.1943,0.0455 -0.40928,0.0455 -0.45888,0 -0.70073,-0.21911 -0.24184,-0.22117 -0.24184,-0.63252 v -0.68626 h 0.50229 v 0.68626 q 0,0.24392 0.10749,0.3452 0.10955,0.10129 0.33279,0.10129 0.20258,0 0.40928,-0.0476 v -1.08313 h 0.5023 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.62563,114.64753 q -0.47749,0 -0.77514,-0.29972 -0.29559,-0.30179 -0.29559,-0.80202 v -0.062 q 0,-0.33486 0.12816,-0.59738 0.13022,-0.26458 0.3638,-0.41134 0.23357,-0.14676 0.5209,-0.14676 0.45681,0 0.70486,0.29145 0.25011,0.29146 0.25011,0.82476 v 0.20257 h -1.4614 q 0.0227,0.27698 0.18396,0.43821 0.1633,0.16123 0.40928,0.16123 0.3452,0 0.56224,-0.27905 l 0.27078,0.25838 q -0.13435,0.20051 -0.35966,0.31213 -0.22324,0.10955 -0.5023,0.10955 z m -0.0599,-1.91616 q -0.20671,0 -0.33486,0.1447 -0.1261,0.14469 -0.16124,0.40307 h 0.95705 v -0.0372 q -0.0165,-0.25218 -0.13436,-0.38033 -0.11782,-0.13023 -0.32659,-0.13023 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.83118,114.24652 q 0.1881,0 0.31213,-0.10955 0.12402,-0.10955 0.13229,-0.27078 h 0.47335 q -0.008,0.20877 -0.13022,0.39067 -0.12196,0.17983 -0.33073,0.28525 -0.20877,0.10542 -0.45062,0.10542 -0.46922,0 -0.74414,-0.30385 -0.27492,-0.30386 -0.27492,-0.83923 v -0.0517 q 0,-0.51056 0.27286,-0.81648 0.27285,-0.30799 0.74414,-0.30799 0.39894,0 0.64905,0.23357 0.25218,0.23151 0.26458,0.60979 h -0.47335 q -0.008,-0.19224 -0.13229,-0.31626 -0.12196,-0.12403 -0.31213,-0.12403 -0.24391,0 -0.3762,0.17777 -0.13229,0.1757 -0.13436,0.53537 v 0.0806 q 0,0.3638 0.13022,0.54364 0.13229,0.17776 0.38034,0.17776 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.88836,112.76858 h -0.72554 v 1.83761 h -0.5023 v -1.83761 h -0.71726 v -0.39894 h 1.9451 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 153.26043,114.60619 v -2.23655 h 0.90743 q 0.45889,0 0.69867,0.16123 0.23978,0.15916 0.23978,0.45888 0,0.15503 -0.0971,0.27906 -0.0951,0.12195 -0.28319,0.1881 0.21911,0.0455 0.34726,0.18397 0.12816,0.13849 0.12816,0.32659 0,0.31213 -0.23151,0.47542 -0.22944,0.1633 -0.66146,0.1633 z m 0.50229,-0.95291 v 0.55604 h 0.54984 q 0.38654,0 0.38654,-0.27699 0,-0.27905 -0.39274,-0.27905 z m 0,-0.35967 h 0.41341 q 0.42788,0 0.42788,-0.25218 0,-0.26458 -0.40514,-0.27285 h -0.43615 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.54039,113.46724 q 0,-0.32866 0.13022,-0.59117 0.13023,-0.26459 0.36587,-0.40515 0.23564,-0.14262 0.54157,-0.14262 0.45268,0 0.7338,0.29145 0.28319,0.29146 0.30593,0.77308 l 0.002,0.11782 q 0,0.33073 -0.12815,0.59118 -0.12609,0.26045 -0.3638,0.40308 -0.23565,0.14262 -0.54571,0.14262 -0.47335,0 -0.75861,-0.31419 -0.28318,-0.31626 -0.28318,-0.84129 z m 0.50229,0.0434 q 0,0.3452 0.14263,0.54157 0.14263,0.1943 0.39687,0.1943 0.25425,0 0.39481,-0.19843 0.14263,-0.19844 0.14263,-0.58085 0,-0.33899 -0.14676,-0.53743 -0.1447,-0.19844 -0.39481,-0.19844 -0.24598,0 -0.39067,0.19637 -0.1447,0.19431 -0.1447,0.58291 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 159.10606,113.38249 q 0,-0.47749 0.12816,-0.90537 0.12815,-0.42994 0.3762,-0.76687 0.24805,-0.339 0.52503,-0.47543 l 0.0992,0.29353 q -0.29145,0.22117 -0.47335,0.67592 -0.17984,0.45269 -0.19638,1.03766 l -0.002,0.17777 q 0,0.62632 0.1757,1.11828 0.17776,0.48989 0.49609,0.74621 l -0.0992,0.27905 q -0.27698,-0.13643 -0.5271,-0.47749 -0.24804,-0.339 -0.3762,-0.76481 -0.12609,-0.42788 -0.12609,-0.93845 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.61294,114.60619 v -2.23655 h 0.90744 q 0.45889,0 0.69866,0.16123 0.23978,0.15916 0.23978,0.45888 0,0.15503 -0.0971,0.27906 -0.0951,0.12195 -0.28319,0.1881 0.21911,0.0455 0.34727,0.18397 0.12816,0.13849 0.12816,0.32659 0,0.31213 -0.23151,0.47542 -0.22945,0.1633 -0.66146,0.1633 z m 0.5023,-0.95291 v 0.55604 h 0.54983 q 0.38654,0 0.38654,-0.27699 0,-0.27905 -0.39274,-0.27905 z m 0,-0.35967 h 0.41341 q 0.42788,0 0.42788,-0.25218 0,-0.26458 -0.40514,-0.27285 h -0.43615 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 164.93516,113.51065 q 0,0.51883 -0.23565,0.82889 -0.23564,0.30799 -0.63252,0.30799 -0.36793,0 -0.58911,-0.24184 v 1.0604 h -0.50229 v -3.09645 h 0.46302 l 0.0207,0.22737 q 0.22117,-0.26871 0.60151,-0.26871 0.40928,0 0.64079,0.30592 0.23358,0.30386 0.23358,0.84543 z m -0.50023,-0.0434 q 0,-0.33486 -0.13436,-0.53123 -0.13229,-0.19637 -0.38034,-0.19637 -0.30799,0 -0.44235,0.25425 v 0.99218 q 0.13643,0.26045 0.44649,0.26045 0.23978,0 0.37413,-0.19223 0.13643,-0.19431 0.13643,-0.58705 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.69629,114.60619 q -0.0331,-0.0641 -0.0579,-0.20877 -0.23978,0.25011 -0.58705,0.25011 -0.33693,0 -0.54983,-0.19223 -0.21291,-0.19224 -0.21291,-0.47543 0,-0.3576 0.26458,-0.54777 0.26665,-0.19223 0.76068,-0.19223 h 0.30799 v -0.14676 q 0,-0.17364 -0.0971,-0.27699 -0.0971,-0.10542 -0.29559,-0.10542 -0.17156,0 -0.28112,0.0868 -0.10955,0.0847 -0.10955,0.21704 h -0.5023 q 0,-0.18397 0.12196,-0.34313 0.12196,-0.16123 0.33073,-0.25218 0.21084,-0.091 0.46922,-0.091 0.39274,0 0.62632,0.19843 0.23357,0.19637 0.23978,0.55397 v 1.00873 q 0,0.30179 0.0848,0.48162 v 0.0351 z m -0.55191,-0.36173 q 0.14883,0 0.27905,-0.0724 0.1323,-0.0724 0.19844,-0.1943 v -0.42168 h -0.27078 q -0.27906,0 -0.41961,0.0971 -0.14056,0.0971 -0.14056,0.27492 0,0.14469 0.0951,0.23151 0.0971,0.0847 0.25838,0.0847 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 169.4434,114.60619 h -0.50229 v -0.74621 q -0.1943,0.0455 -0.40928,0.0455 -0.45888,0 -0.70073,-0.21911 -0.24185,-0.22117 -0.24185,-0.63252 v -0.68626 h 0.5023 v 0.68626 q 0,0.24392 0.10749,0.3452 0.10955,0.10129 0.33279,0.10129 0.20257,0 0.40928,-0.0476 v -1.08313 h 0.50229 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 171.31409,114.60619 q -0.0331,-0.0641 -0.0579,-0.20877 -0.23978,0.25011 -0.58704,0.25011 -0.33693,0 -0.54984,-0.19223 -0.21291,-0.19224 -0.21291,-0.47543 0,-0.3576 0.26459,-0.54777 0.26665,-0.19223 0.76067,-0.19223 h 0.30799 v -0.14676 q 0,-0.17364 -0.0971,-0.27699 -0.0971,-0.10542 -0.29559,-0.10542 -0.17156,0 -0.28112,0.0868 -0.10955,0.0847 -0.10955,0.21704 h -0.5023 q 0,-0.18397 0.12196,-0.34313 0.12196,-0.16123 0.33073,-0.25218 0.21084,-0.091 0.46922,-0.091 0.39274,0 0.62632,0.19843 0.23358,0.19637 0.23978,0.55397 v 1.00873 q 0,0.30179 0.0847,0.48162 v 0.0351 z m -0.55191,-0.36173 q 0.14883,0 0.27906,-0.0724 0.13229,-0.0724 0.19843,-0.1943 v -0.42168 h -0.27078 q -0.27905,0 -0.41961,0.0971 -0.14056,0.0971 -0.14056,0.27492 0,0.14469 0.0951,0.23151 0.0971,0.0847 0.25838,0.0847 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 173.23645,113.41557 q 0,0.45888 -0.12609,0.88676 -0.12609,0.42582 -0.38241,0.77515 -0.25631,0.3514 -0.53536,0.48576 l -0.0992,-0.27905 q 0.31006,-0.23978 0.48989,-0.73174 0.1819,-0.49403 0.1819,-1.12655 v -0.0475 q 0,-0.57464 -0.1571,-1.04593 -0.15709,-0.47336 -0.45061,-0.75861 l -0.0641,-0.0579 0.0992,-0.28112 q 0.26458,0.12816 0.51263,0.45476 0.24804,0.32659 0.38033,0.73173 0.1323,0.40308 0.14883,0.83303 z",
    style: {
      fontWeight: 500,
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path27144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g177155-5",
    transform: "matrix(0.28777705,0,0,0.28777705,84.833157,61.450623)",
    style: {
      fill: "#064e9d",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2756-9",
    style: {
      fill: "#064e9d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.411022,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 2.26772
    },
    d: "m 114.70124,152.12967 c 0,0 0.0108,10.10708 -14.57334,10.05412 -14.232158,-0.0516 -14.573336,-10.05412 -14.573336,-10.05412 H 100.1279 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2756-4-0-1",
    style: {
      fill: "#064e9d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17155,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 2.26772
    },
    d: "m 100.04731,180.57917 6.51558,0.0437 c 0,0 -1.1725,-0.15861 -2.71454,-1.22807 -0.72399,-0.5021 -1.44867,-1.17972 -2.04414,-2.11623 -0.45385,-0.71381 -1.63181,-0.50417 -1.838925,-0.48157 v 0 c -0.207111,-0.0226 -1.325067,-0.23224 -1.778914,0.48157 -0.595468,0.93651 -1.320154,1.61413 -2.044136,2.11623 -1.542046,1.06946 -2.714544,1.22807 -2.714544,1.22807 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2519-9",
    style: {
      fill: "#064e9d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.517704,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 2.26772
    },
    d: "m 101.91428,177.23018 c -0.43052,1.42052 -3.84588,1.58562 -3.873522,0 v -17.16507 m 0,0 c 0.181415,-1.57254 2.093512,-0.93986 3.330972,-0.93986 0.30057,0 0.54255,0.41918 0.54255,0.93986 v 17.16507",
    nodetypes: "cccccsc"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#074e9c",
      fillOpacity: 1,
      strokeWidth: 0.290367,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m 117.95469,102.9588 c -0.49727,-0.0336 -0.98127,0.0303 -1.39528,0.11929 -0.82803,0.17793 -1.71045,0.25445 -1.71045,0.25445 -0.46462,0.18179 -0.93286,0.76344 -0.95424,1.11716 -0.0197,0.32564 1.08793,-0.49743 1.16517,-0.36038 0.22379,0.34459 -0.71516,0.80576 -0.34228,0.77507 0.37289,-0.0307 0.79984,-0.23573 0.94684,-0.30775 0,0 0.17456,-0.30842 0.38305,-0.41483 0.20849,-0.10641 0.60966,-0.21839 0.91636,-0.21627 0.67735,0.005 1.29611,0.0312 1.80627,0.35991 0.85862,0.55329 1.04243,1.20176 0.98373,1.78202 -0.0587,0.58026 -0.2702,1.10266 -0.56821,1.42605 -0.55667,0.60407 -1.23866,1.09416 -3.80121,1.50838 -1.3196,0.21331 -2.66937,0.36368 -3.74307,0.69391 -0.53685,0.16512 -1.007,0.35262 -1.39,0.61999 -0.383,0.26737 -0.70469,0.67644 -0.70469,1.16555 0,0.3455 0.2347,0.66166 0.49035,0.82901 0.25564,0.16736 0.79376,0.26463 1.16488,0.24356 0.63236,-0.0359 1.51359,-0.25598 2.3059,-0.35876 0.78049,-0.10125 2.17116,-0.21478 2.92922,-0.0431 0.66821,0.35211 0.35983,0.73846 0.0524,1.54888 0.19153,0.25278 -0.009,0.0717 0.26205,-0.1067 0,0 0.28863,-0.17881 0.52852,-0.4799 0.3594,-0.44558 0.33625,-1.07148 -0.0593,-1.43477 -0.56055,-0.35387 -1.168,-0.34721 -1.83572,-0.34872 -0.66771,-0.001 -1.2971,0.0188 -2.03841,0.0954 -0.74777,0.0151 -1.83519,0.30495 -2.27568,0.21343 -0.33295,-0.12495 -0.28935,-0.41014 -0.11054,-0.53692 0.20671,-0.14429 0.58921,-0.30832 1.05809,-0.45253 0.93776,-0.28844 2.25777,-0.3317 3.57159,-0.54407 2.69659,-0.43588 3.71361,-1.19166 4.40959,-1.78746 0.45275,-0.38757 0.83717,-1.25516 0.92726,-2.14562 0.0901,-0.89046 -0.31719,-1.98837 -1.49698,-2.74861 -0.46726,-0.30109 -0.97789,-0.43202 -1.47515,-0.46567 z",
    id: "path5135-8",
    nodetypes: "sscscscssssssssssssccccczcccsssssss"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0412\\u0420\\u0410\\u0427",
    transform: "matrix(1.0533438,0,0,0.92841731,82.341022,80.920768)",
    id: "text12111-1",
    style: {
      fontSize: "5.49658px",
      lineHeight: 1.25,
      letterSpacing: "0.458047px",
      wordSpacing: 0,
      fill: "#074e9c",
      strokeWidth: 0.0763415
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22.704801,38.508421 q 0.244233,0 0.370375,-0.107355 0.126143,-0.107355 0.126143,-0.316697 0,-0.206659 -0.126143,-0.314014 -0.126142,-0.110039 -0.370375,-0.110039 h -0.571665 v 0.848105 z m 0.03489,1.752572 q 0.311329,0 0.466994,-0.13151 0.158349,-0.13151 0.158349,-0.397214 0,-0.260336 -0.155665,-0.389162 -0.155665,-0.13151 -0.469678,-0.13151 h -0.606556 v 1.049396 z m 0.960828,-1.441242 q 0.3328,0.09662 0.515304,0.356955 0.182504,0.260337 0.182504,0.638763 0,0.579718 -0.391846,0.864209 -0.391846,0.284491 -1.191642,0.284491 H 21.099843 V 36.95714 h 1.551281 q 0.834686,0 1.207744,0.252285 0.375743,0.252284 0.375743,0.807847 0,0.292542 -0.136878,0.499201 -0.136877,0.203974 -0.397213,0.303278 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Asap"
    },
    id: "path293956-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.747422,36.95714 h 1.714997 q 0.764905,0 1.172854,0.340853 0.410633,0.338168 0.410633,0.966195 0,0.630711 -0.410633,0.971564 -0.407949,0.338168 -1.172854,0.338168 h -0.681705 v 1.390249 h -1.033292 z m 1.033292,0.748802 v 1.119177 h 0.571666 q 0.300594,0 0.464311,-0.14493 0.163716,-0.147613 0.163716,-0.416001 0,-0.268387 -0.163716,-0.413317 -0.163717,-0.144929 -0.464311,-0.144929 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Asap"
    },
    id: "path293958-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.665561,40.234154 h -1.615694 l -0.254968,0.730015 h -1.038661 l 1.484184,-4.007029 h 1.2319 l 1.484184,4.007029 h -1.03866 z M 31.307519,39.49072 h 1.097706 l -0.547511,-1.594223 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Asap"
    },
    id: "path293960-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.345346,40.964169 v -1.52981 h -1.400984 q -0.509937,0 -0.786376,-0.314014 -0.273755,-0.314014 -0.273755,-0.933989 V 36.95714 h 1.033292 v 0.738066 q 0,0.633395 0.0993,0.797112 0.0993,0.161032 0.351588,0.161032 h 0.976931 v -1.69621 h 1.033293 v 4.007029 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Asap"
    },
    id: "path293962-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor1);
export default __webpack_public_path__ + "static/media/Doctor1.f1fe2534483c1286715edc83c1dfbcfc.svg";
export { ForwardRef as ReactComponent };